import { fromEnumAsString, toEnumFromString } from '../../../serialization/enum-utils.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { InvoiceVat } from './invoice-vat.js';
import { InvoiceProvider } from './invoice-provider.js';
import { InvoicingProtocol } from './invoicing-protocol.js';

export class SzamlazzInvoicingProtocol extends InvoicingProtocol {
  static readonly TYPE_ID: string = 'd528f8dfc97244bdb9b089a78f35c320';

  public readonly provider: InvoiceProvider = InvoiceProvider.Szamlazz;

  private constructor(
    public readonly accountId: string,
    public readonly apiKeySecret: string,
    public readonly invoicePrefix: string,
    public readonly vat: InvoiceVat,
    public readonly allowLegalEntities: boolean,
  ) {
    super();
  }

  get $typeId(): string {
    return SzamlazzInvoicingProtocol.TYPE_ID;
  }

  static create(args: {
    accountId: string,
    apiKeySecret: string,
    invoicePrefix: string,
    vat: InvoiceVat,
    allowLegalEntities: boolean,
  }): SzamlazzInvoicingProtocol {
    return new SzamlazzInvoicingProtocol(
        args.accountId,
        args.apiKeySecret,
        args.invoicePrefix,
        args.vat,
        args.allowLegalEntities,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): SzamlazzInvoicingProtocol {
    return new SzamlazzInvoicingProtocol(
        MapUtils.get<string>(map, 'accountId'),
        MapUtils.get<string>(map, 'apiKeySecret'),
        MapUtils.get<string>(map, 'invoicePrefix'),
        toEnumFromString(MapUtils.get<string>(map, 'vat'), InvoiceVat),
        MapUtils.get<boolean>(map, 'allowLegalEntities'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'accountId': this.accountId,
      'apiKeySecret': this.apiKeySecret,
      'invoicePrefix': this.invoicePrefix,
      'provider': fromEnumAsString(this.provider),
      'vat': fromEnumAsString(this.vat),
      'allowLegalEntities': this.allowLegalEntities,
    };
  }

  clone(): this {
    return new SzamlazzInvoicingProtocol(
        this.accountId,
        this.apiKeySecret,
        this.invoicePrefix,
        this.vat,
        this.allowLegalEntities,
    ) as this;
  }

  isSame(other: this): boolean {
    if(this === other) {
      return true;
    }

    return this.accountId === other.accountId &&
        this.apiKeySecret === other.apiKeySecret &&
        this.invoicePrefix === other.invoicePrefix &&
        this.vat === other.vat &&
        this.allowLegalEntities === other.allowLegalEntities;
  }

  static verifyType(dm: DataModel): boolean {
    return dm instanceof SzamlazzInvoicingProtocol;
  }

  static assertType(dm: DataModel): dm is SzamlazzInvoicingProtocol {
    return dm instanceof SzamlazzInvoicingProtocol;
  }
}

export class SzamlazzInvoicingProtocolBuilder extends DataModelBuilder<SzamlazzInvoicingProtocol> {
  build(context: SerializationContext, map: SerializedData): SzamlazzInvoicingProtocol {
    return SzamlazzInvoicingProtocol.fromMap(context, map);
  }
}
